// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "screen and (max-width: 320px)";
var _4 = "wrapper-UdXr_";
var _5 = "header-36AOl";
var _6 = "airline-IWQsN";
var _7 = "airline__logo-1sjZJ";
var _8 = "flight-2jnmI";
var _9 = "flight__block-1O_ef";
var _a = "flight__title-3Umzh";
var _b = "aircraft-3I3bx";
var _c = "aircraft__image-JP02L";
var _d = "aircraft_image_active-1XUyd";
var _e = "aircraft_return-1znas";
var _f = "footer-3p_wb";
var _10 = "airline__number-G68Bx";
var _11 = "airline__name-1e1ZZ";
var _12 = "aircraft__number-nG1iN";
var _13 = "aircraft__name-SC-9N";
var _14 = "aircraft__name_withNoAmenities-1PH1e";
var _15 = "aircraft__name_active-2PER1";
var _16 = "info-1wP5p";
var _17 = "aircraft__nameTitle-2s7ur";
var _18 = "amenities-30F8P";
export { _1 as "__esModule", _2 as "mobile", _3 as "iphone5", _4 as "wrapper", _5 as "header", _6 as "airline", _7 as "airline__logo", _8 as "flight", _9 as "flight__block", _a as "flight__title", _b as "aircraft", _c as "aircraft__image", _d as "aircraft_image_active", _e as "aircraft_return", _f as "footer", _10 as "airline__number", _11 as "airline__name", _12 as "aircraft__number", _13 as "aircraft__name", _14 as "aircraft__name_withNoAmenities", _15 as "aircraft__name_active", _16 as "info", _17 as "aircraft__nameTitle", _18 as "amenities" }
export default { "__esModule": _1, "mobile": _2, "iphone5": _3, "wrapper": _4, "header": _5, "airline": _6, "airline__logo": _7, "flight": _8, "flight__block": _9, "flight__title": _a, "aircraft": _b, "aircraft__image": _c, "aircraft_image_active": _d, "aircraft_return": _e, "footer": _f, "airline__number": _10, "airline__name": _11, "aircraft__number": _12, "aircraft__name": _13, "aircraft__name_withNoAmenities": _14, "aircraft__name_active": _15, "info": _16, "aircraft__nameTitle": _17, "amenities": _18 }
